import { IValuesFilterUsers } from "../RootTypes";

export const valuesDefaultFilterUsers: IValuesFilterUsers = {
  name: "",
  interestLevel: " ",
};
